import './CollectionA.scss';

import { b2x } from '@b2x/react/src';
import React from 'react';

import { ComponentWrapper } from './ComponentWrapper';
import { CollectionAContentType } from './contentTypes';

export const CollectionA = ({ header, options, slides }: CollectionAContentType) => {
  const _headingType = header?.headingType as string;

  return (
    <ComponentWrapper classNames="collection-a" options={options}>
      {header?.title && (
        <b2x.Div className="mb-lg-5 mb-4" textAlign={'center'}>
          {React.createElement(_headingType, { class: 'h1 m-0' }, header.title.toUpperCase())}
        </b2x.Div>
      )}
      {slides?.length && slides.length > 0 && (
        <b2x.SwiperContext>
          {() => (
            <b2x.Div className="collection-container position-relative">
              <b2x.EqualHeight>
                <b2x.Swiper
                  breakpoints={{
                    lg: {
                      grid: {
                        fill: 'row',
                        rows: 3,
                      },

                      slidesPerView: 4,
                      spaceBetween: 8,
                    },
                    xs: {
                      grid: {
                        fill: 'row',
                        rows: 2,
                      },
                      slidesPerView: 2.1,
                      spaceBetween: 4,
                    },
                  }}
                  grid={{ fill: 'row', rows: 2 }}
                  pagination={{
                    clickable: true,
                  }}
                  slides={slides.map((slide) => (
                    <b2x.Div className="slide-container position-relative" key={slide.contentSectionId}>
                      {slide.asset?.type && <b2x.AssetV2 {...slide.asset} />}
                      {(slide.content?.title || slide.content?.cta?.label) && (
                        <b2x.Div
                          alignItems={'end'}
                          className="slide-inner-container position-absolute start-0 top-0 w-100 h-100 pb-4 pb-md-5"
                          display={'flex'}
                          justifyContent={'center'}
                        >
                          <b2x.EqualHeightElement name="collection-content-card">
                            <b2x.Div className="position-relative" textAlign={'center'}>
                              {slide.content.title && (
                                <p className="text-white h3">{b2x.formatHtml(slide.content.title.toUpperCase())}</p>
                              )}
                              {slide.content.cta?.label && (
                                <b2x.CtaFromContent
                                  {...slide.content.cta}
                                  ctaProps={{ button: { className: 'text-white stretched-link btn-sm' } }}
                                  variant="link"
                                />
                              )}
                            </b2x.Div>
                          </b2x.EqualHeightElement>
                        </b2x.Div>
                      )}
                    </b2x.Div>
                  ))}
                  slidesPerView={2}
                  spaceBetween={8}
                />
              </b2x.EqualHeight>
            </b2x.Div>
          )}
        </b2x.SwiperContext>
      )}
    </ComponentWrapper>
  );
};
